/**
 * Company info hook
 * Thin wrapper around data layer using React Query
 */

import { useQuery } from "@tanstack/react-query";
import { companyKeys, queryOptions } from "@/data/query-keys";
import { getCompanyInfo } from "@/data/supabase/companies";
import { getCurrentUserCompanyId } from "@/lib/userUtils";

// Re-export type for backward compatibility
export type { CompanyInfo } from "@/data/supabase/companies";

export const useCompanyInfo = () => {
  return useQuery({
    queryKey: companyKeys.info(),
    queryFn: async () => {
      try {
        const companyId = await getCurrentUserCompanyId();
        if (!companyId) return null;
        return getCompanyInfo(companyId);
      } catch (error: any) {
        // If user doesn't have a company_id yet, return null
        if (error?.message?.includes('company information') || 
            error?.message?.includes('company_id') ||
            error?.message?.includes('Could not retrieve')) {
          return null;
        }
        console.error('Error fetching company info:', error);
        return null;
      }
    },
    retry: false,
    staleTime: queryOptions.company.staleTime,
    gcTime: queryOptions.company.gcTime,
  });
};
